import React, { useState, useEffect, useMemo } from "react";
import socket from "../tools/socke";
import axios from "axios";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import CadetesDashboard from "./CadetesDashboard";
import InfoCadete from "../tools/InfoCadete";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const Listado = () => {
  const Usuario = ObtieneDatosCookies();

  const [visible, setVisible] = useState(false);
  const [info, setInfo] = useState(null);
  const [sede, setSede] = useState("");

  // ============================================================
  // CONTROLES
  // ============================================================

  const [moduloActivo, setModuloActivo] = useState("general");

  const [orden, setOrden] = useState("recientes");

  const [promocionFiltro, setPromocionFiltro] = useState("");
  const [sedeFiltro, setSedeFiltro] = useState("");
  const [divisionFiltro, setDivisionFiltro] = useState("");

  // ============================================================
  // TRAER PRESENTES
  // ============================================================

  const traemeLosPresentes = async () => {
    try {
      const client = axios.create({
        baseURL:
          "https://wwwa.isepsantafe.net.ar/expedientes/devuelvePresentesHoy",
      });

      const dat = await client.post("/", {
        sede: "Recreo",
      });

      if (dat?.data && Array.isArray(dat.data)) {
        setInfo(dat.data);
      } else {
        setInfo([]);
      }
    } catch (error) {
      console.error("Error al obtener los presentes:", error);
      setInfo([]);
    }
  };

  // ============================================================
  // INICIO + SOCKET
  // ============================================================

  useEffect(() => {
    if (Usuario.sedeID == 1) {
      setSede("Provincia");
    } else if (Usuario.sedeID == 2) {
      setSede("Rosario");
    } else {
      setSede("Recreo");
    }

    traemeLosPresentes();

    const handlePresenteCadete = () => {
      traemeLosPresentes();
    };

    socket.on("listaPresentes", handlePresenteCadete);

    return () => {
      socket.off("listaPresentes", handlePresenteCadete);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ============================================================
  // FILTRAR SEGUN SEDE DEL USUARIO
  // ============================================================

  const getFilteredData = (data = []) => {
    if (!Array.isArray(data)) return [];

    // Rosario
    if (Usuario.sedeID == 2) {
      return data.filter(
        (item) => item.cadeteSede == "Rosario"
      );
    }

    // Cualquier sede que no sea Provincial
    if (Usuario.sedeID != 1) {
      return data.filter(
        (item) => item.cadeteSede == "Recreo"
      );
    }

    // Provincial ve todo
    return data;
  };

  // ============================================================
  // FECHA MOSTRABLE
  // ============================================================

  const regresaBienFecha = (dato) => {
    if (!dato) return "-";

    const partes = dato.split("-");

    if (partes.length !== 3) return dato;

    // Si viene YYYY-MM-DD
    if (partes[0].length === 4) {
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    return dato;
  };

  // ============================================================
  // CONVERTIR FECHA + HORA PARA ORDENAMIENTO
  // ============================================================

  const obtenerFechaHora = (item) => {
    try {
      if (!item?.fecha) {
        return new Date(0);
      }

      let fecha = String(item.fecha);

      if (fecha.includes("T")) {
        fecha = fecha.split("T")[0];
      }

      const partes = fecha.split("-");

      let year = 0;
      let month = 0;
      let day = 0;

      if (partes[0]?.length === 4) {
        year = Number(partes[0]);
        month = Number(partes[1]);
        day = Number(partes[2]);
      } else {
        day = Number(partes[0]);
        month = Number(partes[1]);
        year = Number(partes[2]);
      }

      const hora = item.hora || "00:00:00";
      const partesHora = String(hora).split(":");

      const horas = Number(partesHora[0] || 0);
      const minutos = Number(partesHora[1] || 0);
      const segundos = Number(partesHora[2] || 0);

      return new Date(
        year,
        month - 1,
        day,
        horas,
        minutos,
        segundos
      );
    } catch (error) {
      return new Date(0);
    }
  };

  // ============================================================
  // DEVOLVER TEXTO DE DIVISION
  // ============================================================

  const obtenerDivision = (item) => {
    if (item?.division) {
      return item.division;
    }

    if (item?.nombreDivision) {
      return item.nombreDivision;
    }

    return "Sin división";
  };

  // ============================================================
  // TIPO DE ASISTENCIA
  // ============================================================

  const obtenerTipo = (item) => {
    if (!item?.tipo) return "-";

    if (typeof item.tipo === "string") {
      return item.tipo;
    }

    return item.tipo?.tipo || "-";
  };

  // ============================================================
  // ESTADO DE ASISTENCIA
  // ============================================================

  const obtenerEstadoAsistencia = (item) => {
    if (!item?.tipo) return "-";

    if (typeof item.tipo === "object") {
      return item.tipo?.estado || "-";
    }

    return "-";
  };

  // ============================================================
  // ID ASISTENCIA
  // ============================================================

  const obtenerIdAsistencia = (item) => {
    if (!item?.tipo) return "-";

    if (typeof item.tipo === "object") {
      return item.tipo?.id || "-";
    }

    return "-";
  };

  // ============================================================
  // LECTOR
  // ============================================================

  const obtenerLector = (item) => {
    if (!item?.tipo) return "-";

    if (typeof item.tipo === "object") {
      return item.tipo?.lectorId || "-";
    }

    return "-";
  };

  // ============================================================
  // ORDENAR DATOS
  // ============================================================

  const ordenarDatos = (datos = []) => {
    const copia = [...datos];

    switch (orden) {
      // ----------------------------------------------------------
      // HORARIO
      // ----------------------------------------------------------

      case "antiguos":
        return copia.sort(
          (a, b) =>
            obtenerFechaHora(a) -
            obtenerFechaHora(b)
        );

      case "recientes":
        return copia.sort(
          (a, b) =>
            obtenerFechaHora(b) -
            obtenerFechaHora(a)
        );

      // ----------------------------------------------------------
      // APELLIDO
      // ----------------------------------------------------------

      case "apellido":
        return copia.sort((a, b) =>
          `${a.apellido || ""} ${a.nombre || ""}`.localeCompare(
            `${b.apellido || ""} ${b.nombre || ""}`,
            "es"
          )
        );

      case "apellidoDesc":
        return copia.sort((a, b) =>
          `${b.apellido || ""} ${b.nombre || ""}`.localeCompare(
            `${a.apellido || ""} ${a.nombre || ""}`,
            "es"
          )
        );

      // ----------------------------------------------------------
      // PROMOCION
      // ----------------------------------------------------------

      case "promocion":
        return copia.sort((a, b) =>
          String(a.promocion || "").localeCompare(
            String(b.promocion || ""),
            "es"
          )
        );

      // ----------------------------------------------------------
      // COMPAÑIA
      // ----------------------------------------------------------

      case "compania":
        return copia.sort((a, b) =>
          String(a.companiaNombre || "").localeCompare(
            String(b.companiaNombre || ""),
            "es"
          )
        );

      // ----------------------------------------------------------
      // DIVISION
      // ----------------------------------------------------------

      case "division":
        return copia.sort((a, b) =>
          obtenerDivision(a).localeCompare(
            obtenerDivision(b),
            "es",
            {
              numeric: true,
            }
          )
        );

      // ----------------------------------------------------------
      // SEDE
      // ----------------------------------------------------------

      case "sede":
        return copia.sort((a, b) =>
          String(a.cadeteSede || "").localeCompare(
            String(b.cadeteSede || ""),
            "es"
          )
        );

      default:
        return copia.sort(
          (a, b) =>
            obtenerFechaHora(b) -
            obtenerFechaHora(a)
        );
    }
  };

  // ============================================================
  // DATOS PERMITIDOS
  // ============================================================

  const datosPermitidos = useMemo(() => {
    return getFilteredData(info || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info]);

  // ============================================================
  // PROMOCIONES
  // ============================================================

  const promocionesDisponibles = useMemo(() => {
    return [
      ...new Set(
        datosPermitidos
          .map((item) => item.promocion)
          .filter(Boolean)
      ),
    ].sort((a, b) =>
      String(a).localeCompare(String(b), "es", {
        numeric: true,
      })
    );
  }, [datosPermitidos]);

  // ============================================================
  // SEDES
  // ============================================================

  const sedesDisponibles = useMemo(() => {
    return [
      ...new Set(
        datosPermitidos
          .map((item) => item.cadeteSede)
          .filter(Boolean)
      ),
    ].sort();
  }, [datosPermitidos]);

  // ============================================================
  // DIVISIONES
  // ============================================================

  const divisionesDisponibles = useMemo(() => {
    return [
      ...new Set(
        datosPermitidos
          .map((item) => obtenerDivision(item))
          .filter(
            (division) =>
              division &&
              division !== "Sin división"
          )
      ),
    ].sort((a, b) =>
      String(a).localeCompare(String(b), "es", {
        numeric: true,
      })
    );
  }, [datosPermitidos]);

  // ============================================================
  // FILTROS GENERALES
  // ============================================================

  const datosFiltrados = useMemo(() => {
    let datos = [...datosPermitidos];

    if (sedeFiltro) {
      datos = datos.filter(
        (item) =>
          item.cadeteSede === sedeFiltro
      );
    }

    if (promocionFiltro) {
      datos = datos.filter(
        (item) =>
          String(item.promocion) ===
          String(promocionFiltro)
      );
    }

    if (divisionFiltro) {
      datos = datos.filter(
        (item) =>
          obtenerDivision(item) === divisionFiltro
      );
    }

    return ordenarDatos(datos);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    datosPermitidos,
    sedeFiltro,
    promocionFiltro,
    divisionFiltro,
    orden,
  ]);

  // ============================================================
  // AGRUPADOS POR SEDE
  // ============================================================

  const agrupadosPorSede = useMemo(() => {
    const grupos = {};

    datosPermitidos.forEach((item) => {
      const nombreSede =
        item.cadeteSede || "Sin sede";

      if (!grupos[nombreSede]) {
        grupos[nombreSede] = [];
      }

      grupos[nombreSede].push(item);
    });

    Object.keys(grupos).forEach((key) => {
      grupos[key] = ordenarDatos(grupos[key]);
    });

    return grupos;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datosPermitidos, orden]);

  // ============================================================
  // AGRUPADOS POR PROMOCION
  // ============================================================

  const agrupadosPorPromocion = useMemo(() => {
    const grupos = {};

    datosPermitidos.forEach((item) => {
      const promocion =
        item.promocion || "Sin promoción";

      if (!grupos[promocion]) {
        grupos[promocion] = [];
      }

      grupos[promocion].push(item);
    });

    Object.keys(grupos).forEach((key) => {
      grupos[key] = ordenarDatos(grupos[key]);
    });

    return grupos;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datosPermitidos, orden]);

  // ============================================================
  // AGRUPADOS POR DIVISION
  // ============================================================

  const agrupadosPorDivision = useMemo(() => {
    const grupos = {};

    datosPermitidos.forEach((item) => {
      const division = obtenerDivision(item);

      if (!grupos[division]) {
        grupos[division] = [];
      }

      grupos[division].push(item);
    });

    Object.keys(grupos).forEach((key) => {
      grupos[key] = ordenarDatos(grupos[key]);
    });

    return grupos;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datosPermitidos, orden]);

  // ============================================================
  // RESUMEN PROMOCIONES
  // ============================================================

  const resumenPromociones = (datos = []) => {
    const resumen = {};

    datos.forEach((item) => {
      const promocion =
        item.promocion || "Sin promoción";

      resumen[promocion] =
        (resumen[promocion] || 0) + 1;
    });

    return resumen;
  };

  // ============================================================
  // RESUMEN SEDES
  // ============================================================

  const resumenSedes = (datos = []) => {
    const resumen = {};

    datos.forEach((item) => {
      const sedeActual =
        item.cadeteSede || "Sin sede";

      resumen[sedeActual] =
        (resumen[sedeActual] || 0) + 1;
    });

    return resumen;
  };

  // ============================================================
  // RESUMEN DIVISIONES
  // ============================================================

  const resumenDivisiones = (datos = []) => {
    const resumen = {};

    datos.forEach((item) => {
      const division = obtenerDivision(item);

      resumen[division] =
        (resumen[division] || 0) + 1;
    });

    return resumen;
  };

  // ============================================================
  // COLOR COMPAÑIA
  // ============================================================

  const getColorBySeccion = (companiaId) => {
    switch (Number(companiaId)) {
      case 2:
        return "rgb(112, 192, 92)";

      case 3:
        return "rgb(209, 73, 73)";

      case 4:
        return "rgb(214, 16, 155)";

      case 6:
        return "rgb(90, 122, 207)";

      case 7:
        return "rgb(210, 243, 62)";

      case 8:
        return "rgb(190, 132, 85)";

      default:
        return "rgba(201, 201, 201, 0.29)";
    }
  };


  // ============================================================
  // ANALIZAR PRESENTES
  // ============================================================

  const normalizarFecha = (dato) => {
    if (!dato) return "";

    let fecha = String(dato).trim();

    if (fecha.includes("T")) {
      fecha = fecha.split("T")[0];
    }

    if (fecha.includes(" ")) {
      fecha = fecha.split(" ")[0];
    }

    const partes = fecha.split("-");

    if (partes.length !== 3) {
      return fecha;
    }

    // YYYY-MM-DD
    if (partes[0].length === 4) {
      return `${partes[0]}-${String(partes[1]).padStart(2, "0")}-${String(
        partes[2]
      ).padStart(2, "0")}`;
    }

    // DD-MM-YYYY
    return `${partes[2]}-${String(partes[1]).padStart(2, "0")}-${String(
      partes[0]
    ).padStart(2, "0")}`;
  };

  const escaparHtml = (valor) =>
    String(valor ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");


  // ============================================================
  // EXPORTAR ANALISIS DE PRESENTES A EXCEL
  // ============================================================

  const exportarAnalisisPresentesExcel = (
    datos,
    grupos,
    grupoDominante,
    gruposAtipicos,
    umbralAtipico
  ) => {
    try {
      if (!datos?.length) {
        Swal.fire({
          title: "Sin datos",
          text: "No hay datos para exportar.",
          icon: "info",
        });
        return;
      }

      const wb = XLSX.utils.book_new();

      // ========================================================
      // HOJA 1 - RESUMEN GENERAL
      // ========================================================

      const dnisTotales = new Set(
        datos
          .map((item) => String(item.dni || "").trim())
          .filter(Boolean)
      );

      const resumenGeneral = [
        {
          Concepto: "Cadetes únicos analizados",
          Valor: dnisTotales.size,
        },
        {
          Concepto: "Registros analizados",
          Valor: datos.length,
        },
        {
          Concepto: "Cantidad de fechas encontradas",
          Valor: grupos.length,
        },
        {
          Concepto: "Fecha principal",
          Valor:
            grupoDominante?.fecha !== "Sin fecha"
              ? regresaBienFecha(grupoDominante?.fecha)
              : "Sin fecha",
        },
        {
          Concepto: "Cadetes en fecha principal",
          Valor: grupoDominante?.cantidadCadetes || 0,
        },
        {
          Concepto: "Registros en fecha principal",
          Valor: grupoDominante?.cantidadRegistros || 0,
        },
        {
          Concepto: "Umbral para detectar grupos atípicos",
          Valor: umbralAtipico,
        },
        {
          Concepto: "Grupos para revisar",
          Valor: gruposAtipicos.length,
        },
      ];

      const wsResumen = XLSX.utils.json_to_sheet(resumenGeneral);
      wsResumen["!cols"] = [{ wch: 52 }, { wch: 25 }];

      XLSX.utils.book_append_sheet(
        wb,
        wsResumen,
        "Resumen Analisis"
      );

      // ========================================================
      // HOJA 2 - DISTRIBUCION POR FECHA
      // ========================================================

      const distribucionFechas = grupos.map((grupo) => {
        const esPrincipal =
          grupo.fecha === grupoDominante?.fecha;

        const esAtipico = gruposAtipicos.some(
          (x) => x.fecha === grupo.fecha
        );

        let clasificacion = "Normal";

        if (esPrincipal) {
          clasificacion = "GRUPO PRINCIPAL";
        } else if (esAtipico) {
          clasificacion = "REVISAR";
        }

        return {
          Fecha:
            grupo.fecha !== "Sin fecha"
              ? regresaBienFecha(grupo.fecha)
              : "Sin fecha",
          "Cadetes únicos": grupo.cantidadCadetes,
          "Cantidad de registros": grupo.cantidadRegistros,
          Clasificación: clasificacion,
          "Diferencia con principal":
            (grupoDominante?.cantidadCadetes || 0) -
            grupo.cantidadCadetes,
        };
      });

      const wsFechas =
        XLSX.utils.json_to_sheet(distribucionFechas);

      wsFechas["!cols"] = [
        { wch: 18 },
        { wch: 20 },
        { wch: 22 },
        { wch: 22 },
        { wch: 25 },
      ];

      XLSX.utils.book_append_sheet(
        wb,
        wsFechas,
        "Distribucion por Fecha"
      );

      // ========================================================
      // HOJA 3 - PRESENTES A REVISAR
      // ========================================================

      const detalleAtipicos = [];

      gruposAtipicos.forEach((grupo) => {
        const vistos = new Set();

        grupo.registros
          .slice()
          .sort(
            (a, b) =>
              obtenerFechaHora(b) - obtenerFechaHora(a)
          )
          .forEach((item) => {
            const dni = String(item.dni || "").trim();

            if (!dni || vistos.has(dni)) {
              return;
            }

            vistos.add(dni);

            let relacionFecha = "Misma fecha";

            if (
              grupo.timestamp >
              grupoDominante.timestamp
            ) {
              relacionFecha = "Posterior";
            } else if (
              grupo.timestamp <
              grupoDominante.timestamp
            ) {
              relacionFecha = "Anterior";
            }

            detalleAtipicos.push({
              Fecha:
                grupo.fecha !== "Sin fecha"
                  ? regresaBienFecha(grupo.fecha)
                  : "Sin fecha",
              "Relación con fecha principal": relacionFecha,
              DNI: item.dni || "-",
              Apellido: item.apellido || "-",
              Nombre: item.nombre || "-",
              Cadete:
                `${item.apellido || ""} ${
                  item.nombre || ""
                }`.trim() || "-",
              Hora: item.hora || "-",
              Sede: item.cadeteSede || "-",
              Promoción: item.promocion || "-",
              División: obtenerDivision(item),
              Sección: item.seccionNombre || "-",
              Compañía: item.companiaNombre || "-",
              "Tipo Asistencia": obtenerTipo(item),
              "Estado Asistencia":
                obtenerEstadoAsistencia(item),
              "ID Asistencia":
                obtenerIdAsistencia(item),
              "ID Lector": obtenerLector(item),
            });
          });
      });

      const wsAtipicos = XLSX.utils.json_to_sheet(
        detalleAtipicos.length
          ? detalleAtipicos
          : [
              {
                Resultado:
                  "No se detectaron grupos atípicos.",
              },
            ]
      );

      wsAtipicos["!cols"] = [
        { wch: 16 },
        { wch: 28 },
        { wch: 14 },
        { wch: 25 },
        { wch: 25 },
        { wch: 40 },
        { wch: 14 },
        { wch: 18 },
        { wch: 15 },
        { wch: 30 },
        { wch: 25 },
        { wch: 30 },
        { wch: 25 },
        { wch: 20 },
        { wch: 18 },
        { wch: 15 },
      ];

      XLSX.utils.book_append_sheet(
        wb,
        wsAtipicos,
        "Presentes a Revisar"
      );

      // ========================================================
      // HOJA 4 - TODOS LOS REGISTROS ANALIZADOS
      // ========================================================

      const todosLosRegistros = datos
        .slice()
        .sort(
          (a, b) =>
            obtenerFechaHora(b) - obtenerFechaHora(a)
        )
        .map((item, index) => {
          const fechaNormalizada =
            normalizarFecha(item.fecha);

          const grupo = grupos.find(
            (x) => x.fecha === fechaNormalizada
          );

          const esPrincipal =
            fechaNormalizada ===
            grupoDominante?.fecha;

          const esAtipico = gruposAtipicos.some(
            (x) => x.fecha === fechaNormalizada
          );

          let clasificacion = "Normal";

          if (esPrincipal) {
            clasificacion = "GRUPO PRINCIPAL";
          } else if (esAtipico) {
            clasificacion = "REVISAR";
          }

          return {
            "#": index + 1,
            Fecha: regresaBienFecha(item.fecha),
            Hora: item.hora || "-",
            DNI: item.dni || "-",
            Apellido: item.apellido || "-",
            Nombre: item.nombre || "-",
            Cadete:
              `${item.apellido || ""} ${
                item.nombre || ""
              }`.trim() || "-",
            Sede: item.cadeteSede || "-",
            Promoción: item.promocion || "-",
            División: obtenerDivision(item),
            Sección: item.seccionNombre || "-",
            Compañía: item.companiaNombre || "-",
            "Tipo Asistencia": obtenerTipo(item),
            "Estado Asistencia":
              obtenerEstadoAsistencia(item),
            "ID Asistencia":
              obtenerIdAsistencia(item),
            "ID Lector": obtenerLector(item),
            Clasificación: clasificacion,
            "Cadetes en esa fecha":
              grupo?.cantidadCadetes || 0,
            "Registros en esa fecha":
              grupo?.cantidadRegistros || 0,
          };
        });

      const wsTodos =
        XLSX.utils.json_to_sheet(todosLosRegistros);

      wsTodos["!cols"] = [
        { wch: 6 },
        { wch: 16 },
        { wch: 14 },
        { wch: 14 },
        { wch: 25 },
        { wch: 25 },
        { wch: 40 },
        { wch: 18 },
        { wch: 15 },
        { wch: 30 },
        { wch: 25 },
        { wch: 30 },
        { wch: 25 },
        { wch: 20 },
        { wch: 18 },
        { wch: 15 },
        { wch: 22 },
        { wch: 22 },
        { wch: 22 },
      ];

      XLSX.utils.book_append_sheet(
        wb,
        wsTodos,
        "Todos los Analizados"
      );

      // ========================================================
      // DESCARGAR ARCHIVO
      // ========================================================

      const ahora = new Date();

      const fechaArchivo = ahora
        .toLocaleDateString("es-AR")
        .replaceAll("/", "-");

      const horaArchivo = ahora
        .toLocaleTimeString("es-AR")
        .replaceAll(":", "-");

      XLSX.writeFile(
        wb,
        `Analisis_Presentes_${fechaArchivo}_${horaArchivo}.xlsx`
      );
    } catch (error) {
      console.error(
        "Error exportando análisis de presentes:",
        error
      );

      Swal.fire({
        title: "Error",
        text: "No se pudo generar el Excel del análisis.",
        icon: "error",
      });
    }
  };

  const analizarPresentes = () => {
    // IMPORTANTE:
    // El análisis SIEMPRE se hace sobre TODOS los presentes que
    // el usuario tiene permitido ver según su sede/permisos.
    // Los filtros visuales de sede, promoción y división NO afectan
    // este análisis para evitar diagnósticos incompletos.
    const datos = Array.isArray(datosPermitidos)
      ? datosPermitidos
      : [];

    const hayFiltrosActivos = Boolean(
      sedeFiltro || promocionFiltro || divisionFiltro
    );

    if (!datos.length) {
      Swal.fire({
        title: "Sin datos para analizar",
        text: "No hay presentes disponibles para analizar.",
        icon: "info",
      });
      return;
    }

    // ----------------------------------------------------------
    // AGRUPAR POR FECHA
    // ----------------------------------------------------------

    const gruposPorFecha = {};

    datos.forEach((item) => {
      const fechaKey = normalizarFecha(item.fecha) || "Sin fecha";
      const dni = String(item.dni || "").trim();

      if (!gruposPorFecha[fechaKey]) {
        gruposPorFecha[fechaKey] = {
          fecha: fechaKey,
          registros: [],
          dnis: new Set(),
        };
      }

      gruposPorFecha[fechaKey].registros.push(item);

      if (dni) {
        gruposPorFecha[fechaKey].dnis.add(dni);
      }
    });

    const grupos = Object.values(gruposPorFecha).map((grupo) => ({
      fecha: grupo.fecha,
      registros: grupo.registros,
      cantidadRegistros: grupo.registros.length,
      cantidadCadetes: grupo.dnis.size,
      dnis: [...grupo.dnis],
      timestamp:
        grupo.fecha !== "Sin fecha"
          ? new Date(`${grupo.fecha}T00:00:00`).getTime()
          : 0,
    }));

    grupos.sort((a, b) => b.timestamp - a.timestamp);

    // ----------------------------------------------------------
    // GRUPO DOMINANTE
    // ----------------------------------------------------------

    const grupoDominante = [...grupos].sort(
      (a, b) => b.cantidadCadetes - a.cantidadCadetes
    )[0];

    const umbralAtipico = Math.max(
      4,
      Math.ceil(grupoDominante.cantidadCadetes * 0.08)
    );

    // ----------------------------------------------------------
    // GRUPOS QUE LLAMAN LA ATENCIÓN
    //
    // Ejemplo:
    // 200 cadetes de una fecha y 3 o 4 de otra.
    // ----------------------------------------------------------

    const gruposAtipicos = grupos.filter((grupo) => {
      if (grupo.fecha === grupoDominante.fecha) {
        return false;
      }

      return grupo.cantidadCadetes <= umbralAtipico;
    });

    const gruposMasNuevos = gruposAtipicos.filter(
      (grupo) => grupo.timestamp > grupoDominante.timestamp
    );

    const gruposMasViejos = gruposAtipicos.filter(
      (grupo) => grupo.timestamp < grupoDominante.timestamp
    );

    // ----------------------------------------------------------
    // CADetes ÚNICOS TOTALES
    // ----------------------------------------------------------

    const dnisTotales = new Set(
      datos
        .map((item) => String(item.dni || "").trim())
        .filter(Boolean)
    );

    // ----------------------------------------------------------
    // ARMAR DETALLE POR FECHA
    // ----------------------------------------------------------

    const detalleFechas = grupos
      .map((grupo) => {
        const esDominante =
          grupo.fecha === grupoDominante.fecha;

        const esAtipico = gruposAtipicos.some(
          (x) => x.fecha === grupo.fecha
        );

        const fondo = esDominante
          ? "#e8f5e9"
          : esAtipico
          ? "#fff3e0"
          : "#f8f9fa";

        const borde = esDominante
          ? "#43a047"
          : esAtipico
          ? "#fb8c00"
          : "#dee2e6";

        return `
          <div style="
            display:flex;
            justify-content:space-between;
            gap:15px;
            align-items:center;
            padding:9px 11px;
            margin-bottom:6px;
            background:${fondo};
            border:1px solid ${borde};
            border-radius:8px;
          ">
            <div style="text-align:left;">
              <strong>${escaparHtml(
                grupo.fecha === "Sin fecha"
                  ? "Sin fecha"
                  : regresaBienFecha(grupo.fecha)
              )}</strong>
              ${
                esDominante
                  ? `<span style="margin-left:7px; font-size:11px; color:#2e7d32;">GRUPO PRINCIPAL</span>`
                  : esAtipico
                  ? `<span style="margin-left:7px; font-size:11px; color:#ef6c00;">REVISAR</span>`
                  : ""
              }
            </div>

            <div style="text-align:right; white-space:nowrap;">
              <strong>${grupo.cantidadCadetes}</strong> cadetes
              <span style="color:#777; font-size:12px;">
                (${grupo.cantidadRegistros} registros)
              </span>
            </div>
          </div>
        `;
      })
      .join("");

    // ----------------------------------------------------------
    // DETALLE DE GRUPOS ATÍPICOS
    // ----------------------------------------------------------

    const renderGrupoAtipico = (grupo, tipo) => {
      const cadetesUnicos = [];

      const vistos = new Set();

      grupo.registros
        .slice()
        .sort(
          (a, b) =>
            obtenerFechaHora(b) -
            obtenerFechaHora(a)
        )
        .forEach((item) => {
          const dni = String(item.dni || "").trim();

          if (!dni || vistos.has(dni)) {
            return;
          }

          vistos.add(dni);

          cadetesUnicos.push(item);
        });

      const resumenSedePromocion = {};

      cadetesUnicos.forEach((item) => {
        const sedeCadete = item.cadeteSede || "Sin sede";
        const promocionCadete = item.promocion || "Sin promoción";
        const clave = `${sedeCadete}||${promocionCadete}`;

        if (!resumenSedePromocion[clave]) {
          resumenSedePromocion[clave] = {
            sede: sedeCadete,
            promocion: promocionCadete,
            cantidad: 0,
          };
        }

        resumenSedePromocion[clave].cantidad++;
      });

      const detalleSedePromocion = Object.values(resumenSedePromocion)
        .sort((a, b) => b.cantidad - a.cantidad)
        .map(
          (grupo) => `
            <span style="
              display:inline-block;
              margin:2px 5px 2px 0;
              padding:4px 8px;
              border-radius:12px;
              background:#ffffff;
              border:1px solid #d7dce1;
              font-size:12px;
            ">
              <strong>${escaparHtml(grupo.sede)}</strong>
              · Promoción ${escaparHtml(grupo.promocion)}
              · ${grupo.cantidad}
            </span>
          `
        )
        .join("");

      const listado = cadetesUnicos
        .slice(0, 12)
        .map(
          (item) => `
            <li style="margin-bottom:7px;">
              <strong>${escaparHtml(
                `${item.apellido || ""} ${item.nombre || ""}`.trim() ||
                  item.dni ||
                  "Cadete"
              )}</strong>
              — DNI ${escaparHtml(item.dni || "-")}
              — ${escaparHtml(item.hora || "-")}
              <br/>
              <span style="font-size:12px; color:#555;">
                🏫 ${escaparHtml(item.cadeteSede || "Sin sede")}
                · 🎓 Promoción ${escaparHtml(item.promocion || "Sin promoción")}
                · 👥 ${escaparHtml(obtenerDivision(item))}
                · ${escaparHtml(item.companiaNombre || "Sin compañía")}
              </span>
            </li>
          `
        )
        .join("");

      return `
        <div style="
          text-align:left;
          margin-top:10px;
          padding:12px;
          border-radius:9px;
          background:${tipo === "nuevo" ? "#e3f2fd" : "#fff8e1"};
          border:1px solid ${
            tipo === "nuevo" ? "#90caf9" : "#ffe082"
          };
        ">
          <div style="margin-bottom:6px;">
            <strong>
              ${
                tipo === "nuevo"
                  ? "🆕 Grupo más nuevo"
                  : "🕒 Grupo más antiguo"
              }:
              ${escaparHtml(regresaBienFecha(grupo.fecha))}
            </strong>
          </div>

          <div style="margin-bottom:7px;">
            ${grupo.cantidadCadetes} cadetes únicos
            (${grupo.cantidadRegistros} registros)
          </div>

          ${
            detalleSedePromocion
              ? `<div style="margin-bottom:8px;">${detalleSedePromocion}</div>`
              : ""
          }

          ${
            listado
              ? `<ul style="margin:0; padding-left:20px;">${listado}</ul>`
              : ""
          }

          ${
            cadetesUnicos.length > 12
              ? `<div style="margin-top:5px; color:#666; font-size:12px;">
                  y ${cadetesUnicos.length - 12} cadetes más...
                </div>`
              : ""
          }
        </div>
      `;
    };

    const detalleAtipicos = [
      ...gruposMasNuevos.map((g) =>
        renderGrupoAtipico(g, "nuevo")
      ),
      ...gruposMasViejos.map((g) =>
        renderGrupoAtipico(g, "viejo")
      ),
    ].join("");

    // ----------------------------------------------------------
    // MENSAJE DE INTERPRETACIÓN
    // ----------------------------------------------------------

    let observacion = "";

    if (!gruposAtipicos.length) {
      observacion = `
        <div style="
          margin-top:12px;
          padding:10px;
          border-radius:8px;
          background:#e8f5e9;
          color:#2e7d32;
          text-align:left;
        ">
          ✅ No aparecen grupos pequeños de fechas distintas que
          resulten llamativos según el criterio automático.
        </div>
      `;
    } else {
      observacion = `
        <div style="
          margin-top:12px;
          padding:10px;
          border-radius:8px;
          background:#fff3e0;
          color:#e65100;
          text-align:left;
        ">
          ⚠️ Se detectaron <strong>${gruposAtipicos.length}</strong>
          grupos pequeños en fechas diferentes al grupo principal.
          Conviene revisar esos presentes porque podrían ser marcas
          que quedaron activas de otro momento.
        </div>
      `;
    }

    // ----------------------------------------------------------
    // MOSTRAR INFORME
    // ----------------------------------------------------------

    Swal.fire({
      title: "🔎 Análisis de presentes",
      width: 900,
      html: `
        <div style="text-align:left; font-size:14px;">

          <div style="
            margin-bottom:14px;
            padding:11px 13px;
            border-radius:9px;
            background:#e8f4fd;
            border:1px solid #90caf9;
            color:#174a6e;
          ">
            <strong>ANÁLISIS GENERAL</strong><br/>
            Se analizaron todos los presentes que este usuario tiene permitido visualizar.
            Los filtros de pantalla <strong>no se aplican</strong> a este análisis.
          </div>

          ${
            hayFiltrosActivos
              ? `
                <div style="
                  margin-bottom:14px;
                  padding:10px 12px;
                  border-radius:9px;
                  background:#fff8e1;
                  border:1px solid #ffe082;
                  color:#7a5400;
                ">
                  ⚠️ Actualmente hay filtros activos en la pantalla, pero fueron
                  <strong>ignorados</strong> para este análisis general.
                </div>
              `
              : ""
          }

          <div style="
            display:grid;
            grid-template-columns:repeat(auto-fit,minmax(150px,1fr));
            gap:8px;
            margin-bottom:15px;
          ">
            <div style="
              padding:10px;
              border-radius:8px;
              background:#f4f6f7;
              text-align:center;
            ">
              <div style="font-size:12px; color:#666;">
                Cadetes únicos
              </div>
              <strong style="font-size:22px;">
                ${dnisTotales.size}
              </strong>
            </div>

            <div style="
              padding:10px;
              border-radius:8px;
              background:#f4f6f7;
              text-align:center;
            ">
              <div style="font-size:12px; color:#666;">
                Registros activos
              </div>
              <strong style="font-size:22px;">
                ${datos.length}
              </strong>
            </div>

            <div style="
              padding:10px;
              border-radius:8px;
              background:#e8f5e9;
              text-align:center;
            ">
              <div style="font-size:12px; color:#666;">
                Fecha principal
              </div>
              <strong style="font-size:17px;">
                ${escaparHtml(
                  regresaBienFecha(grupoDominante.fecha)
                )}
              </strong>
            </div>

            <div style="
              padding:10px;
              border-radius:8px;
              background:#fff3e0;
              text-align:center;
            ">
              <div style="font-size:12px; color:#666;">
                Grupos para revisar
              </div>
              <strong style="font-size:22px;">
                ${gruposAtipicos.length}
              </strong>
            </div>
          </div>

          <div style="margin-bottom:8px;">
            <strong>Distribución de presentes por fecha</strong>
          </div>

          <div style="
            max-height:260px;
            overflow:auto;
            padding-right:4px;
          ">
            ${detalleFechas}
          </div>

          ${observacion}

          ${detalleAtipicos}
        </div>
      `,
      icon: gruposAtipicos.length ? "warning" : "info",
      showCancelButton: true,
      confirmButtonText: "📥 Exportar Excel",
      cancelButtonText: "Cerrar",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (result.isConfirmed) {
        exportarAnalisisPresentesExcel(
          datos,
          grupos,
          grupoDominante,
          gruposAtipicos,
          umbralAtipico
        );
      }
    });
  };

  // ============================================================
  // EXCEL
  // ============================================================

  const exportToExcel = () => {
    if (!datosFiltrados?.length) {
      alert("No hay presentes para exportar.");
      return;
    }

    // ========================================================
    // HOJA PRINCIPAL - TODOS LOS DATOS
    // ========================================================

    const datosExcel = datosFiltrados.map(
      (item, index) => ({
        "#": index + 1,

        "ID Asistencia":
          obtenerIdAsistencia(item),

        DNI:
          item.dni || "-",

        Apellido:
          item.apellido || "-",

        Nombre:
          item.nombre || "-",

        Cadete:
          `${item.apellido || ""} ${
            item.nombre || ""
          }`.trim(),

        Sede:
          item.cadeteSede || "-",

        Promoción:
          item.promocion || "-",

        "ID Sección":
          item.seccionId ?? "-",

        Sección:
          item.seccionNombre || "-",

        "ID Compañía":
          item.companiaId ?? "-",

        Compañía:
          item.companiaNombre || "-",

        "ID División":
          item.divisionId ?? "-",

        División:
          item.division || "-",

        "Nombre División":
          item.nombreDivision || "-",

        "Tipo de Asistencia":
          obtenerTipo(item),

        "Estado Asistencia":
          obtenerEstadoAsistencia(item),

        "ID Lector":
          obtenerLector(item),

        Fecha:
          regresaBienFecha(item.fecha),

        Hora:
          item.hora || "-",
      })
    );

    const ws =
      XLSX.utils.json_to_sheet(datosExcel);

    // ========================================================
    // ANCHOS DE COLUMNAS
    // ========================================================

    ws["!cols"] = [
      { wch: 6 },  // #
      { wch: 15 }, // asistencia
      { wch: 14 }, // dni
      { wch: 22 }, // apellido
      { wch: 22 }, // nombre
      { wch: 38 }, // cadete
      { wch: 15 }, // sede
      { wch: 15 }, // promo
      { wch: 12 }, // id seccion
      { wch: 20 }, // seccion
      { wch: 14 }, // id compañia
      { wch: 25 }, // compañia
      { wch: 13 }, // id division
      { wch: 35 }, // division
      { wch: 30 }, // nombre division
      { wch: 24 }, // tipo
      { wch: 20 }, // estado
      { wch: 12 }, // lector
      { wch: 15 }, // fecha
      { wch: 14 }, // hora
    ];

    // ========================================================
    // HOJA RESUMEN POR SEDE
    // ========================================================

    const resumenSedeExcel = Object.entries(
      agrupadosPorSede
    ).map(([nombreSede, datos]) => ({
      Sede: nombreSede,
      "Cantidad de presentes": datos.length,
    }));

    const wsSedes =
      XLSX.utils.json_to_sheet(
        resumenSedeExcel
      );

    wsSedes["!cols"] = [
      { wch: 25 },
      { wch: 25 },
    ];

    // ========================================================
    // HOJA RESUMEN POR PROMOCION
    // ========================================================

    const resumenPromocionExcel =
      Object.entries(
        agrupadosPorPromocion
      ).map(([promo, datos]) => ({
        Promoción: promo,
        "Cantidad de presentes":
          datos.length,
      }));

    const wsPromociones =
      XLSX.utils.json_to_sheet(
        resumenPromocionExcel
      );

    wsPromociones["!cols"] = [
      { wch: 25 },
      { wch: 25 },
    ];

    // ========================================================
    // HOJA RESUMEN POR DIVISION
    // ========================================================

    const resumenDivisionExcel =
      Object.entries(
        agrupadosPorDivision
      ).map(([division, datos]) => ({
        División: division,
        "Cantidad de presentes":
          datos.length,

        Sede:
          [
            ...new Set(
              datos
                .map((x) => x.cadeteSede)
                .filter(Boolean)
            ),
          ].join(", "),

        Promoción:
          [
            ...new Set(
              datos
                .map((x) => x.promocion)
                .filter(Boolean)
            ),
          ].join(", "),
      }));

    const wsDivisiones =
      XLSX.utils.json_to_sheet(
        resumenDivisionExcel
      );

    wsDivisiones["!cols"] = [
      { wch: 40 },
      { wch: 25 },
      { wch: 20 },
      { wch: 20 },
    ];

    // ========================================================
    // CREAR LIBRO
    // ========================================================

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Presentes"
    );

    XLSX.utils.book_append_sheet(
      wb,
      wsSedes,
      "Resumen por Sede"
    );

    XLSX.utils.book_append_sheet(
      wb,
      wsPromociones,
      "Resumen por Promocion"
    );

    XLSX.utils.book_append_sheet(
      wb,
      wsDivisiones,
      "Resumen por Division"
    );

    // ========================================================
    // NOMBRE ARCHIVO
    // ========================================================

    const fecha = new Date();

    const nombre =
      sede === "Provincia"
        ? "Presentes ambas sedes"
        : `Presentes ${sede}`;

    const fechaArchivo =
      fecha
        .toLocaleDateString("es-AR")
        .replaceAll("/", "-");

    const horaArchivo =
      fecha
        .toLocaleTimeString("es-AR")
        .replaceAll(":", "-");

    XLSX.writeFile(
      wb,
      `${nombre} ${fechaArchivo} ${horaArchivo}.xlsx`
    );
  };

  // ============================================================
  // TABLA REUTILIZABLE
  // ============================================================

  const TablaPresentes = ({ datos }) => {
    if (!datos?.length) {
      return (
        <div
          style={{
            padding: "25px",
            textAlign: "center",
            color: "#777",
          }}
        >
          No hay presentes para mostrar.
        </div>
      );
    }

    return (
      <div
        style={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "1250px",
          }}
        >
          <thead>
            <tr
              style={{
                background: "#34495e",
                color: "#fff",
              }}
            >
              <th style={estiloTh}>#</th>

              <th style={estiloTh}>
                Fecha
              </th>

              <th style={estiloTh}>
                Hora
              </th>

              <th style={estiloTh}>
                DNI
              </th>

              <th style={estiloTh}>
                Cadete
              </th>

              <th style={estiloTh}>
                Sede
              </th>

              <th style={estiloTh}>
                Promoción
              </th>

              <th style={estiloTh}>
                División
              </th>

              <th style={estiloTh}>
                Sección
              </th>

              <th style={estiloTh}>
                Compañía
              </th>

              <th style={estiloTh}>
                Tipo
              </th>

              <th style={estiloTh}>
                Estado
              </th>

            </tr>
          </thead>

          <tbody>
            {datos.map((item, index) => {
              const division =
                obtenerDivision(item);

              return (
                <tr
                  key={`${
                    obtenerIdAsistencia(item)
                  }-${item.dni}-${
                    item.fecha
                  }-${item.hora}-${index}`}
                  onClick={() =>
                    InfoCadete(item.dni)
                  }
                  style={{
                    backgroundColor:
                      index % 2 === 0
                        ? "#f8f9fa"
                        : "#ffffff",

                    cursor: "pointer",
                    color: "#333",
                  }}
                >
                  <td style={estiloTd}>
                    {index + 1}
                  </td>

                  <td
                    style={{
                      ...estiloTd,
                      fontWeight: "600",
                    }}
                  >
                    {regresaBienFecha(item.fecha)}
                  </td>

                  <td
                    style={{
                      ...estiloTd,
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    {item.hora || "-"}
                  </td>

                  <td style={estiloTd}>
                    {item.dni || "-"}
                  </td>

                  <td style={estiloTd}>
                    <strong>
                      {item.apellido || ""}{" "}
                      {item.nombre || ""}
                    </strong>
                  </td>

                  <td style={estiloTd}>
                    {item.cadeteSede || "-"}
                  </td>

                  <td style={estiloTd}>
                    {item.promocion || "-"}
                  </td>

                  <td
                    style={{
                      ...estiloTd,
                      fontWeight:
                        division !==
                        "Sin división"
                          ? "bold"
                          : "normal",
                    }}
                  >
                    {division}
                  </td>

                  <td style={estiloTd}>
                    {item.seccionNombre || "-"}
                  </td>

                  <td
                    style={{
                      ...estiloTd,
                      backgroundColor:
                        getColorBySeccion(
                          item.companiaId
                        ),
                    }}
                  >
                    {item.companiaNombre || "-"}
                  </td>

                  <td style={estiloTd}>
                    {obtenerTipo(item)}
                  </td>

                  <td style={estiloTd}>
                    {obtenerEstadoAsistencia(
                      item
                    )}
                  </td>

                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  // ============================================================
  // ESTILOS INTERNOS
  // ============================================================

  const estiloTh = {
    textAlign: "left",
    padding: "10px",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    background: "#34495e",
    zIndex: 2,
  };

  const estiloTd = {
    padding: "9px 10px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
    whiteSpace: "nowrap",
  };

  const estiloBotonModulo = (activo) => ({
    border: "none",
    borderRadius: "8px",
    padding: "10px 18px",
    cursor: "pointer",
    fontWeight: "bold",
    background:
      activo
        ? "#34495e"
        : "#e9ecef",

    color:
      activo
        ? "#fff"
        : "#444",
  });

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ====================================================== */}
      {/* DASHBOARD */}
      {/* ====================================================== */}

      <div>
        {sede ? (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            {sede === "Rosario" && (
              <CadetesDashboard sede="Rosario" />
            )}

            {sede === "Recreo" && (
              <CadetesDashboard sede="Recreo" />
            )}

            {sede === "Provincia" && (
              <>
                <CadetesDashboard sede="Recreo" />

                <CadetesDashboard sede="Rosario" />
              </>
            )}
          </div>
        ) : null}
      </div>

      {/* ====================================================== */}
      {/* PRESENTES */}
      {/* ====================================================== */}

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: "30px",
        }}
      >
        <h4
          style={{
            border: "1px solid grey",
            width: "350px",
            background: "#456",
            textAlign: "center",
            margin: "5px",
            color: "#eee",
            borderRadius: "10px",
            padding: "8px",
            cursor: "pointer",
          }}
          onClick={() =>
            setVisible(!visible)
          }
        >
          {visible
            ? "Ocultar Presentes en Tiempo Real"
            : "Ver Presentes en Tiempo Real"}
        </h4>

        {visible && (
          <div
            style={{
              width: "98%",
              maxWidth: "1600px",
              marginTop: "20px",
            }}
          >
            {/* ================================================== */}
            {/* RESUMEN */}
            {/* ================================================== */}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "10px",
                marginBottom: "15px",
              }}
            >
              <div style={estiloResumen}>
                <small>
                  Presentes actuales
                </small>

                <strong>
                  {datosPermitidos.length}
                </strong>
              </div>

              {Object.entries(
                agrupadosPorSede
              ).map(
                ([nombreSede, datos]) => (
                  <div
                    key={nombreSede}
                    style={estiloResumen}
                  >
                    <small>
                      {nombreSede}
                    </small>

                    <strong>
                      {datos.length}
                    </strong>
                  </div>
                )
              )}

              {promocionesDisponibles.map(
                (promo) => (
                  <div
                    key={promo}
                    style={estiloResumen}
                  >
                    <small>
                      Promoción {promo}
                    </small>

                    <strong>
                      {
                        datosPermitidos.filter(
                          (item) =>
                            String(
                              item.promocion
                            ) ===
                            String(promo)
                        ).length
                      }
                    </strong>
                  </div>
                )
              )}
            </div>

            {/* ================================================== */}
            {/* BOTONES MODULOS */}
            {/* ================================================== */}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                flexWrap: "wrap",
                marginBottom: "15px",
              }}
            >
              <button
                style={estiloBotonModulo(
                  moduloActivo === "general"
                )}
                onClick={() =>
                  setModuloActivo("general")
                }
              >
                📋 Tiempo Real
              </button>

              <button
                style={estiloBotonModulo(
                  moduloActivo === "sede"
                )}
                onClick={() =>
                  setModuloActivo("sede")
                }
              >
                🏫 Por Sede
              </button>

              <button
                style={estiloBotonModulo(
                  moduloActivo === "promocion"
                )}
                onClick={() =>
                  setModuloActivo("promocion")
                }
              >
                🎓 Por Promoción
              </button>

              <button
                style={estiloBotonModulo(
                  moduloActivo === "division"
                )}
                onClick={() =>
                  setModuloActivo("division")
                }
              >
                👥 Por División
              </button>

              <button
                type="button"
                onClick={analizarPresentes}
                style={{
                  ...estiloBotonModulo(false),
                  background: "#6f42c1",
                  color: "#fff",
                  border: "1px solid #5a32a3",
                }}
              >
                🔎 Analizar presentes
              </button>
            </div>

            {/* ================================================== */}
            {/* ORDENAMIENTO + FILTROS */}
            {/* ================================================== */}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "10px",
                padding: "12px",
                background: "#f4f6f7",
                borderRadius: "10px",
                marginBottom: "15px",
              }}
            >
              <select
                value={orden}
                onChange={(e) =>
                  setOrden(e.target.value)
                }
                style={estiloSelect}
              >
                <option value="recientes">
                  Más recientes primero
                </option>

                <option value="antiguos">
                  Más antiguos primero
                </option>

                <option value="apellido">
                  Apellido A-Z
                </option>

                <option value="apellidoDesc">
                  Apellido Z-A
                </option>

                <option value="promocion">
                  Por promoción
                </option>

                <option value="division">
                  Por división
                </option>

                <option value="compania">
                  Por compañía
                </option>

                <option value="sede">
                  Por sede
                </option>
              </select>

              {moduloActivo ===
                "general" && (
                <>
                  <select
                    value={sedeFiltro}
                    onChange={(e) =>
                      setSedeFiltro(
                        e.target.value
                      )
                    }
                    style={estiloSelect}
                  >
                    <option value="">
                      Todas las sedes
                    </option>

                    {sedesDisponibles.map(
                      (s) => (
                        <option
                          key={s}
                          value={s}
                        >
                          {s}
                        </option>
                      )
                    )}
                  </select>

                  <select
                    value={
                      promocionFiltro
                    }
                    onChange={(e) =>
                      setPromocionFiltro(
                        e.target.value
                      )
                    }
                    style={estiloSelect}
                  >
                    <option value="">
                      Todas las promociones
                    </option>

                    {promocionesDisponibles.map(
                      (p) => (
                        <option
                          key={p}
                          value={p}
                        >
                          Promoción {p}
                        </option>
                      )
                    )}
                  </select>

                  <select
                    value={divisionFiltro}
                    onChange={(e) =>
                      setDivisionFiltro(
                        e.target.value
                      )
                    }
                    style={estiloSelect}
                  >
                    <option value="">
                      Todas las divisiones
                    </option>

                    {divisionesDisponibles.map(
                      (d) => (
                        <option
                          key={d}
                          value={d}
                        >
                          {d}
                        </option>
                      )
                    )}
                  </select>

                  {(sedeFiltro ||
                    promocionFiltro ||
                    divisionFiltro) && (
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setSedeFiltro("");
                        setPromocionFiltro("");
                        setDivisionFiltro("");
                      }}
                    >
                      Limpiar filtros
                    </button>
                  )}
                </>
              )}
            </div>

            {/* ================================================== */}
            {/* GENERAL */}
            {/* ================================================== */}

            {moduloActivo ===
              "general" && (
              <section style={estiloModulo}>
                <div
                  style={
                    estiloTituloModulo
                  }
                >
                  <div>
                    <small>
                      MONITOREO
                    </small>

                    <h4
                      style={{
                        margin: 0,
                      }}
                    >
                      Presentes en tiempo real
                    </h4>
                  </div>

                  <strong>
                    {
                      datosFiltrados.length
                    }{" "}
                    registros
                  </strong>
                </div>

                <div
                  style={{
                    maxHeight: "600px",
                    overflow: "auto",
                  }}
                >
                  <TablaPresentes
                    datos={
                      datosFiltrados
                    }
                  />
                </div>
              </section>
            )}

            {/* ================================================== */}
            {/* POR SEDE */}
            {/* ================================================== */}

            {moduloActivo === "sede" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                {Object.entries(
                  agrupadosPorSede
                ).map(
                  ([
                    nombreSede,
                    datos,
                  ]) => {
                    const promociones =
                      resumenPromociones(
                        datos
                      );

                    const divisiones =
                      resumenDivisiones(
                        datos
                      );

                    return (
                      <section
                        key={
                          nombreSede
                        }
                        style={
                          estiloModulo
                        }
                      >
                        <div
                          style={
                            estiloTituloModulo
                          }
                        >
                          <div>
                            <small>
                              SEDE
                            </small>

                            <h3
                              style={{
                                margin: 0,
                                color:
                                  "#34495e",
                              }}
                            >
                              {
                                nombreSede
                              }
                            </h3>
                          </div>

                          <div
                            style={{
                              textAlign:
                                "right",
                            }}
                          >
                            <strong
                              style={{
                                fontSize:
                                  "26px",
                              }}
                            >
                              {
                                datos.length
                              }
                            </strong>

                            <div>
                              presentes
                            </div>
                          </div>
                        </div>

                        <div
                          style={
                            estiloBadgesContainer
                          }
                        >
                          {Object.entries(
                            promociones
                          ).map(
                            ([
                              promo,
                              cantidad,
                            ]) => (
                              <span
                                key={
                                  promo
                                }
                                style={
                                  estiloBadge
                                }
                              >
                                Promoción{" "}
                                {promo}:{" "}
                                <strong>
                                  {
                                    cantidad
                                  }
                                </strong>
                              </span>
                            )
                          )}
                        </div>

                        <div
                          style={
                            estiloBadgesContainer
                          }
                        >
                          {Object.entries(
                            divisiones
                          ).map(
                            ([
                              division,
                              cantidad,
                            ]) => (
                              <span
                                key={
                                  division
                                }
                                style={
                                  estiloBadgeDivision
                                }
                              >
                                {
                                  division
                                }
                                :{" "}
                                <strong>
                                  {
                                    cantidad
                                  }
                                </strong>
                              </span>
                            )
                          )}
                        </div>

                        <div
                          style={{
                            maxHeight:
                              "500px",
                            overflow:
                              "auto",
                          }}
                        >
                          <TablaPresentes
                            datos={datos}
                          />
                        </div>
                      </section>
                    );
                  }
                )}
              </div>
            )}

            {/* ================================================== */}
            {/* POR PROMOCION */}
            {/* ================================================== */}

            {moduloActivo ===
              "promocion" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                {Object.entries(
                  agrupadosPorPromocion
                ).map(
                  ([
                    promocion,
                    datos,
                  ]) => {
                    const sedes =
                      resumenSedes(datos);

                    const divisiones =
                      resumenDivisiones(
                        datos
                      );

                    return (
                      <section
                        key={
                          promocion
                        }
                        style={
                          estiloModulo
                        }
                      >
                        <div
                          style={
                            estiloTituloModulo
                          }
                        >
                          <div>
                            <small>
                              PROMOCIÓN
                            </small>

                            <h3
                              style={{
                                margin: 0,
                                color:
                                  "#34495e",
                              }}
                            >
                              {
                                promocion
                              }
                            </h3>
                          </div>

                          <div
                            style={{
                              textAlign:
                                "right",
                            }}
                          >
                            <strong
                              style={{
                                fontSize:
                                  "26px",
                              }}
                            >
                              {
                                datos.length
                              }
                            </strong>

                            <div>
                              presentes
                            </div>
                          </div>
                        </div>

                        <div
                          style={
                            estiloBadgesContainer
                          }
                        >
                          {Object.entries(
                            sedes
                          ).map(
                            ([
                              nombreSede,
                              cantidad,
                            ]) => (
                              <span
                                key={
                                  nombreSede
                                }
                                style={
                                  estiloBadge
                                }
                              >
                                {
                                  nombreSede
                                }
                                :{" "}
                                <strong>
                                  {
                                    cantidad
                                  }
                                </strong>
                              </span>
                            )
                          )}
                        </div>

                        <div
                          style={
                            estiloBadgesContainer
                          }
                        >
                          {Object.entries(
                            divisiones
                          ).map(
                            ([
                              division,
                              cantidad,
                            ]) => (
                              <span
                                key={
                                  division
                                }
                                style={
                                  estiloBadgeDivision
                                }
                              >
                                {
                                  division
                                }
                                :{" "}
                                <strong>
                                  {
                                    cantidad
                                  }
                                </strong>
                              </span>
                            )
                          )}
                        </div>

                        <div
                          style={{
                            maxHeight:
                              "500px",
                            overflow:
                              "auto",
                          }}
                        >
                          <TablaPresentes
                            datos={datos}
                          />
                        </div>
                      </section>
                    );
                  }
                )}
              </div>
            )}

            {/* ================================================== */}
            {/* POR DIVISION */}
            {/* ================================================== */}

            {moduloActivo ===
              "division" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                {Object.entries(
                  agrupadosPorDivision
                ).map(
                  ([
                    division,
                    datos,
                  ]) => {
                    const sedes =
                      resumenSedes(datos);

                    const promociones =
                      resumenPromociones(
                        datos
                      );

                    return (
                      <section
                        key={
                          division
                        }
                        style={
                          estiloModulo
                        }
                      >
                        <div
                          style={
                            estiloTituloModulo
                          }
                        >
                          <div>
                            <small>
                              DIVISIÓN
                            </small>

                            <h3
                              style={{
                                margin: 0,
                                color:
                                  "#34495e",
                              }}
                            >
                              {
                                division
                              }
                            </h3>
                          </div>

                          <div
                            style={{
                              textAlign:
                                "right",
                            }}
                          >
                            <strong
                              style={{
                                fontSize:
                                  "28px",
                              }}
                            >
                              {
                                datos.length
                              }
                            </strong>

                            <div
                              style={{
                                fontSize:
                                  "12px",
                                color:
                                  "#777",
                              }}
                            >
                              presentes
                            </div>
                          </div>
                        </div>

                        <div
                          style={
                            estiloBadgesContainer
                          }
                        >
                          {Object.entries(
                            sedes
                          ).map(
                            ([
                              nombreSede,
                              cantidad,
                            ]) => (
                              <span
                                key={
                                  nombreSede
                                }
                                style={
                                  estiloBadge
                                }
                              >
                                {
                                  nombreSede
                                }
                                :{" "}
                                <strong>
                                  {
                                    cantidad
                                  }
                                </strong>
                              </span>
                            )
                          )}

                          {Object.entries(
                            promociones
                          ).map(
                            ([
                              promo,
                              cantidad,
                            ]) => (
                              <span
                                key={
                                  `promo-${promo}`
                                }
                                style={
                                  estiloBadgeDivision
                                }
                              >
                                Promoción{" "}
                                {promo}:{" "}
                                <strong>
                                  {
                                    cantidad
                                  }
                                </strong>
                              </span>
                            )
                          )}
                        </div>

                        <div
                          style={{
                            maxHeight:
                              "500px",
                            overflow:
                              "auto",
                          }}
                        >
                          <TablaPresentes
                            datos={datos}
                          />
                        </div>
                      </section>
                    );
                  }
                )}
              </div>
            )}

            {/* ================================================== */}
            {/* EXCEL */}
            {/* ================================================== */}

            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: "20px",
              }}
            >
              <button
                onClick={
                  exportToExcel
                }
                className="btn btn-success"
                style={{
                  padding:
                    "10px 25px",
                  fontWeight: "bold",
                }}
              >
                Descargar Excel PRESENTES ACTUALES
              </button>

              <div
                style={{
                  fontSize: "12px",
                  color: "#777",
                  marginTop: "7px",
                }}
              >
                El Excel respeta los
                filtros aplicados y contiene
                los datos completos de
                sede, promoción, división,
                sección, compañía y
                marcación.
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

// ============================================================
// ESTILOS GENERALES
// ============================================================

const estiloModulo = {
  background: "#fff",
  border: "1px solid #ddd",
  borderRadius: "12px",
  padding: "15px",
  boxShadow:
    "0 2px 8px rgba(0,0,0,0.08)",
};

const estiloTituloModulo = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "15px",
  marginBottom: "15px",
  borderBottom: "1px solid #eee",
  paddingBottom: "10px",
};

const estiloResumen = {
  minWidth: "130px",
  background: "#fff",
  border: "1px solid #ddd",
  borderRadius: "9px",
  padding: "8px 15px",
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  boxShadow:
    "0 1px 4px rgba(0,0,0,.06)",
};

const estiloBadge = {
  padding: "5px 10px",
  borderRadius: "15px",
  background: "#edf2f7",
  color: "#34495e",
  fontSize: "13px",
};

const estiloBadgeDivision = {
  padding: "5px 10px",
  borderRadius: "15px",
  background: "#e8f4f8",
  color: "#21618c",
  fontSize: "13px",
};

const estiloBadgesContainer = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  marginBottom: "12px",
};

const estiloSelect = {
  padding: "7px 10px",
  borderRadius: "7px",
  border: "1px solid #bbb",
  minWidth: "190px",
  background: "#fff",
};

export default Listado;